import { h } from 'preact';
{/*
  Modification : added verticale scrollbar in model
  Bug : T2131 All forms need header locks and vertical scroll bar.
  BY : Ganesh Bobade
  ON: 14 Feb 2025
  */}
//double crollbar is showing in model so one vertical srollbar is removed
export const Modal = ({ onClose, title, children, isThisPreviewModal, modalSize, modalHeight, modalStyle }) => {
  return (
    <div class="modal" style={modalStyle}  className={'modal ' + (isThisPreviewModal ? 'previewModalStyling' : '')}>
      <div className={'modal-content scrollable ' + modalSize + (modalHeight ? (' ' + modalHeight) : '')} style="margin: 0 auto">
        <header class="modal-header">
          <h6>{title}</h6>
          <a class="close" onClick={onClose}>
            x
          </a>
        </header>
        { children }
      </div>
    </div>
  );
};

export const ModalBody = ({ children, modalBodyHeight, modalStyle }) => {
  return (
    <section style={modalStyle ? modalStyle : ''} class={'modal-body ' + (modalBodyHeight ? (' ' + modalBodyHeight) : '')}>
      { children }
    </section>
  );
};

export const ModalFooter = ({ children }) => {
  return (
    <footer class="modal-footer">
      { children }
    </footer>
  );
};
